import { Helmet } from "react-helmet-async";
import { APP_TITLE } from "../../constant";
import { Box, Typography, useTheme } from "@mui/material";
import InterviewsTable from "../../modules/Interviews/InterviewsTable";
import { useEffect, useState } from "react";
import { AxiosService } from "../../services/axios/axiosService";
import toast from "react-hot-toast";

const Interviews = () => {
  const theme = useTheme();
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInterviews = async () => {
      try {
        const response = await AxiosService.get("/api/Position");
        setPositions(response);
      } catch (err) {
        // toast.error(
        //   err.message || "Oops! Something went wrong while retrieving the data."
        // );
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchInterviews();
  }, []);

  return (
    <>
      <Helmet>
        <title>Job Positions | {APP_TITLE}</title>
        <meta name="Job Positions" content="Monitor job positions" />
      </Helmet>

      <Box
        sx={{
          p: 4,
          backgroundColor: theme.palette.background.default,
          minHeight: "100vh",
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                mb: 0.5,
              }}
            >
              Job Positions
            </Typography>
          </Box>
        </Box>
        <InterviewsTable positions={positions} loading={loading} />
      </Box>
    </>
  );
};

export default Interviews;
